// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPriorPlanYearDto
 */
export interface IPriorPlanYearDto {
    /**
     * 
     * @type {number}
     * @memberof IPriorPlanYearDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPriorPlanYearDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPriorPlanYearDto
     */
    valid_from?: string;
    /**
     * 
     * @type {string}
     * @memberof IPriorPlanYearDto
     */
    valid_to?: string;
}

/**
 * Check if a given object implements the IPriorPlanYearDto interface.
 */
export function instanceOfIPriorPlanYearDto(value: object): value is IPriorPlanYearDto {
    return true;
}

export function IPriorPlanYearDtoFromJSON(json: any): IPriorPlanYearDto {
    return IPriorPlanYearDtoFromJSONTyped(json, false);
}

export function IPriorPlanYearDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPriorPlanYearDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'valid_from': json['valid_from'] == null ? undefined : json['valid_from'],
        'valid_to': json['valid_to'] == null ? undefined : json['valid_to'],
    };
}

export function IPriorPlanYearDtoToJSON(json: any): IPriorPlanYearDto {
    return IPriorPlanYearDtoToJSONTyped(json, false);
}

export function IPriorPlanYearDtoToJSONTyped(value?: IPriorPlanYearDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'valid_from': value['valid_from'],
        'valid_to': value['valid_to'],
    };
}

